export const definePlugin = (pluginName, method) => {
  $.fn[pluginName] = function(methodOrOptions, ...args) {
    if (typeof methodOrOptions !== 'string') {
      this.each(function() {
        if (!$.data(this, pluginName)) {
          const plugin = method(this, methodOrOptions, ...args);
          $.data(this, pluginName, plugin);
        }
      });
    } else {
      const customPlugins = getCustomPlugin(pluginName, this);

      args = args || [];

      const methodArgs = (args.length > 1) ? Array.prototype.slice.call(args, 1) : [];
      let results = null;

      this.each(function(index) {
        results = applyMethod(pluginName, customPlugins, methodOrOptions, index, methodArgs);
      });

      return (results) ? results[0] : [];
    }

    return this;
  };

  return $.fn[pluginName];
};

export const getCustomPlugin = (pluginName, $elements) => {
  const customPlugins = [];
  $elements.each(function() {
    const $el = $(this);
    const customPlugin = $el.data(pluginName);

    customPlugins.push(customPlugin);
  });

  return customPlugins;
};

export const applyMethod = (
  pluginName, customPlugins,
  method, index, ...args) => {
  const customPlugin = customPlugins[index];
  const results = [];

  if (!customPlugin) {
    throw new Error(`$.${pluginName} not instantiated yet`);
  }

  if (typeof customPlugin[method] !== 'function') {
    throw new Error(`Method ${method} not defined in ${pluginName}`);
  }

  let result = customPlugin[method](...args);
  results.push(result);

  return results;
};
